// main.js
import { createApp } from "vue";
import { createPinia } from "pinia";
import App from "./App.vue";
import router from "./router";
import i18n from "./i18n";
import setupInterceptors from "./services/setupInterceptors";
import vuetify from "./plugins/vuetify";
import { loadFonts } from "./plugins/webfontloader";
import { createToastInterface } from "vue-toastification";
import { VueFlow } from "@vue-flow/core";
import Toast from "vue-toastification";
import { useMainStore } from "./stores/store";
import VueDatePicker from "@vuepic/vue-datepicker";
import "@vuepic/vue-datepicker/dist/main.css";

// import "./helpers.js";

import "./assets/scss/styles.scss";
import "@vue-flow/core/dist/style.css";
import "@vue-flow/core/dist/theme-default.css";
import "vue-toastification/dist/index.css"; // Import default styles
import { VueDraggableNext } from "vue-draggable-next";

// Create the Vue app instance
const app = createApp(App);

// Create Pinia instance
const pinia = createPinia();

// Configure Toast options (optional)
const toastOptions = {
  position: "bottom-center",
  timeout: 2000,
  closeOnClick: true,
  pauseOnFocusLoss: true,
  transition: "my-custom-fade",
  draggable: true,
  icon: false,
  draggablePercent: 0.6,
  maxToasts: 3,
  newestOnTop: true,
  hideProgressBar: true
};

// Create the toast instance and provide it to the app
const toast = createToastInterface(toastOptions);
app.provide("toast", toast);
app.config.globalProperties.$toast = toast;

// Setup interceptors for Axios
setupInterceptors();
loadFonts();

// Register global components (make sure to register before mounting)
import HomeSidebar from "./components/home/home-sidebar";

import WorkspaceSettingsSidebar from "./components/settings/workspace-settings-sidebar";

app.component("home-sidebar", HomeSidebar);
app.component("workspace-settings-sidebar", WorkspaceSettingsSidebar);

app.component("VueDatePicker", VueDatePicker);
app.component("draggable", VueDraggableNext);
// Use Pinia and other plugins
app.use(pinia);
const mainStore = useMainStore();
app.provide("mainStore", mainStore);
app.use(router);
app.use(vuetify);
app.use(Toast, toastOptions);

app.use(VueFlow);
app.use(i18n);

// Finally, mount the app
app.mount("#app");
